import { Component, OnInit, NgZone, ViewChild, ElementRef } from '@angular/core';
import { GlobalService } from '@common/global';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormdataService } from '@services/formdata.service';
import { SaveService } from '@services/save.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CategoryService } from '@services/category.service';
import { CATEGORYEDIT } from '@category/sra_category_edit';
import { Helper } from '@category/helper';
import * as _ from 'lodash';
import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
@Component({
  selector: 'app-calbum',
  templateUrl: './calbum.component.html',
  styleUrls: ['./calbum.component.sass']
})
export class CalbumComponent implements OnInit {
  public config: DropzoneConfigInterface = {
    acceptedFiles: 'image/*',
    clickable: true
  };
  pathToMedia:any={};
  image_paths:any=[];
  btn_process=false;
  autocomplete_load = false;
  params: any = [];
  appCreateForm: FormGroup;
  application = "";
  country = "";
  component = "";
  category = "";
  privacy_list:any=[];
  error: any = { 'name': '','categoryJson' :''};
  selected_category="";
  constructor(private _categoryService: CategoryService, private fb: FormBuilder, private _saveService: SaveService, private _formdataService: FormdataService, private route: ActivatedRoute, private _global: GlobalService, private router: Router) {
    this.component = this._global.COMPONENTS_SMN;
    this.application = "album";
    this.appCreateForm = this.fb.group({
      name: [],
      description: [],
      privacy:['public'],
      location:[]
    });
    let THIS = this;
    let p = {
      'component': this.component,
      'application': 'category',
      'categoryType': this.application
    };
    this._categoryService.application(p).subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          let result = this._global.getVal(data, 'response', '');
          CATEGORYEDIT.init(result, '#' + this.application + '_category', true, "categoryTree", '', this.application, true);
          $("div#" + this.application + "_category").click(function (e) {
            var $target = $(e.target);
            if ($target.attr("id") === "categoryCheck") {
              THIS.selected_category = Helper.categoryJsonText("categoryCheck");
            }
          });
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
    let f = {
      'component': this.component,
      'application': this.application
    };
    this._formdataService.common(f, 'mediaVisibility').subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          this.privacy_list = this._global.getVal(data, 'response', '');

        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });

  }

  ngOnInit(): void {
  }
  save() {
    this.error = { 'name': '','categoryJson' :''};
    this.btn_process = true;
    let r = this.appCreateForm.value;
    r.component = this.component;
    r.application = this.application;
    r.setType=this.application;
    let p = this._global.paramsRemoveNull(r);
    p.categoryJson = Helper.getCategoryChecboxValues("categoryCheck", '');
    p.pathToMedia=JSON.stringify(this.pathToMedia);
    this._saveService.app(p).subscribe(
      data => {

        let severity = 'success';
        let message = '';
        if (this._global.getVal(data, 'status', '') == 1) {
          message = this._global.getVal(data, 'message.info', '');
          this._global.showMessage({ type: severity, message: message });
          this.router.navigate(['/my/' + this.application]);
        } else {
          this.btn_process = false;
          message = this._global.getVal(data, 'message.error', '');
          severity = 'warning';
          for (let key in data["errors"]) {
            this.error[key] = this._global.getVal(data, 'errors.' + key + '.message', '');
          }
          this._global.showMessage({ type: severity, message: message });
        }

      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }
  public onUploadInit(args: any): void {
    args["options"]["params"] = this._global.getUploadParams(this.application, this.component, 'photo', '');
  }
  public onUploadError(args: any): void {
    this._global.showMessage({ type: 'warning', message: args[1] });
  }

  public onUploadSuccess(args: any): void {
    let res=JSON.parse(args[1]);
    this.pathToMedia[res['id']]=this._global.getUploadPathToMedia(res);
    this.image_paths=[];
    this.image_paths.push(this.pathToMedia);
  }
  removeImg(id) {
    if (this.image_paths[0]) {
      this.pathToMedia = this._global.removePathToMediaImage(this.pathToMedia, id);
      this.image_paths = [];
      this.image_paths.push(this.pathToMedia);
    }
  }
  returnZero() {
    return 0
  }
}
